import * as React from "react";
import { Navigate } from "react-router-dom";
import { useUserRole } from "@/hooks/useUserRole";
import { Skeleton } from "@/components/ui/skeleton";

interface RoleBasedRouteProps {
  children: React.ReactNode;
  adminOnly?: boolean;
  restrictedRoles?: ('admin' | 'user' | 'viewer')[];
}

export const RoleBasedRoute = ({ 
  children, 
  adminOnly = false,
  restrictedRoles = []
}: RoleBasedRouteProps) => {
  const { role, loading } = useUserRole();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Skeleton className="h-8 w-32" />
      </div>
    );
  }

  // Check if current role is in the restricted list
  if (role && restrictedRoles.includes(role)) {
    return <Navigate to="/sales" replace />;
  }

  // Allow both admins and viewers to access admin-only routes
  // Viewers get read-only access (enforced in components)
  if (adminOnly && role !== 'admin' && role !== 'viewer') {
    return <Navigate to="/sales" replace />;
  }

  return <>{children}</>;
};
